import { useState, useEffect, useRef } from 'react';
// QUILL
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';

interface DescTypes {
	label: string;
	id: string;
	infoMessage?: string;
	isFormSubmitted: boolean;
	parentClass?: string;
	placeholder?: string;
	required?: boolean;
	value?: string;
	heightInPx?: string;
	handleChange: (value: string) => void;
}

const DescriptionTextArea = ({
	label,
	id,
	infoMessage,
	isFormSubmitted,
	parentClass = 'flex justify-between items-center w-full mb-2',
	required = false,
	handleChange,
	heightInPx = '125',
	value
}: DescTypes) => {
	const [hideInfoMessage, setHideInfoMessage] = useState<boolean>(true);
	const lastCursorPosition = useRef<number | null>(null);
	const isUserTyping = useRef<boolean>(false);

	const { quill, quillRef } = useQuill({
		modules: {
			toolbar: [
				['bold', 'italic', 'underline', 'strike'],
				[{ align: [] }],
				[{ list: 'ordered' }, { list: 'bullet' }],
				// [{ size: ['small', false, 'large', 'huge'] }],
				[{ color: [] }, { background: [] }],

				['clean']
			]
		}
	});

	useEffect(() => {
		if (quill !== undefined && quill !== null) {
			// Store cursor position before any changes
			quill.on(
				'selection-change',
				(range: { index: number; length: number } | null) => {
					if (range?.index !== undefined && range.index !== null) {
						lastCursorPosition.current = range.index;
					}
				}
			);

			// Detect user typing vs programmatic changes
			quill.on('text-change', (delta: any, oldDelta: any, source: string) => {
				if (source === 'user') {
					isUserTyping.current = true;

					// Get the new cursor position after user input
					const range = quill.getSelection();
					if (range?.index !== undefined) {
						lastCursorPosition.current = range.index;
					}
				}
			});

			// Handle the actual text change
			quill.on('text-change', (_delta: any, _oldDelta: any, source: string) => {
				// eslint-disable-next-line
				const text = `${quill?.root.innerHTML}`;
				handleChange(text);

				if (text === '<p><br></p>' || text === '') {
					setHideInfoMessage(false);
				} else {
					setHideInfoMessage(true);
				}

				// Restore cursor position after programmatic changes
				if (source === 'api' && lastCursorPosition.current !== null) {
					setTimeout(() => {
						quill.setSelection(lastCursorPosition.current, 0);
					}, 0);
				}
			});

			// Handle external value changes
			if (
				value !== undefined &&
				value !== null &&
				value !== '' &&
				value !== quill.root.innerHTML &&
				!isUserTyping.current
			) {
				quill.clipboard.dangerouslyPasteHTML(value);
			} else if (value === '' || value === undefined || value === null) {
				// Clear the editor when value is empty
				quill.setText('');
			}

			if (isFormSubmitted) {
				quill.root.innerHTML = '<p><br></p>';
			}

			// Reset user typing flag after a short delay
			if (isUserTyping.current) {
				setTimeout(() => {
					isUserTyping.current = false;
				}, 100);
			}
		}

		// return () => {
		// quill.setText('');
		// };
	}, [quill, quillRef, isFormSubmitted, value, handleChange]);

	return (
		<div className={parentClass}>
			<label htmlFor={id} className='block w-full'>
				<span className='text-sm text-gray-600 font-light'>
					<div className='flex justify-between items-center'>
						{label}
						{required && (
							<sub className='text-gray-400' hidden={hideInfoMessage}>
								(requerido)
							</sub>
						)}
					</div>
				</span>
				<div
					ref={quillRef}
					style={{ height: `${heightInPx}px` }}
					// onKeyUp={() => {
					// // eslint-disable-next-line
					// const desc = `${quill?.root.innerHTML}`;
					// handleChange(desc);
					// if (desc === '<p><br></p>') {
					// setHideInfoMessage(false);
					// }
					// }}

					id='description'
				/>
				{infoMessage !== undefined && (
					<small className='text-red-400' hidden={hideInfoMessage}>
						{infoMessage}
					</small>
				)}
			</label>
		</div>
	);
};

export default DescriptionTextArea;
